import { render, staticRenderFns } from "./tutup_sementara.vue?vue&type=template&id=c7a7aaae&scoped=true"
import script from "./tutup_sementara.vue?vue&type=script&lang=js"
export * from "./tutup_sementara.vue?vue&type=script&lang=js"
import style0 from "./tutup_sementara.vue?vue&type=style&index=0&id=c7a7aaae&prod&lang=scss"
import style1 from "./tutup_sementara.vue?vue&type=style&index=1&id=c7a7aaae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a7aaae",
  null
  
)

export default component.exports